import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import greenTick from "../../../assets/images/forgot-password/greenTick.png";
import './forgot-password.scss';

const Success = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ textAlign: "center", mt: 6 }}>
      <p
        className="grey-color fw-500 fs-40">
        Reset Password
      </p>
      <img src={greenTick} alt="Green Tick" />
      <Box component="div" sx={{ mt: 6 }} className="grey-color fs-16">
        Your password has been updated successfully.
      </Box>
      <button
        className="forgot-btn btn-primary fw-700 cursor-pointer"
        onClick={() => navigate("/authentication/signin")}
        style={{ marginTop: "50px" }}
      >
        SAVE
      </button>
    </Box>
  );
};
export default Success;
